import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {ContractedWork} from "../../models/contractor/ContractedWork";
import {
    ContractedWorkActionTypes,
    FETCH_CONTRACTED_WORKS,
    FETCH_CONTRACTED_WORKS_ERROR,
    FETCH_CONTRACTED_WORKS_SUCCESS
} from "../../actions/contractors/ContractedWorkActions";

export interface ContractedWorkState {
    [ key: number ]: BasicReducerState< Nullable< ContractedWork[] >, Nullable< ContractedWork > >
}

export function ContractedWorkReducer(
    state: ContractedWorkState = {},
    action: ContractedWorkActionTypes
) {

    switch (action.type) {
        case FETCH_CONTRACTED_WORKS:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        current: null,
                        request: startFetchingRequestState()
                    },
                }
            };
        case FETCH_CONTRACTED_WORKS_SUCCESS:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    totalEntries: action.payload.totalEntries,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CONTRACTED_WORKS_ERROR:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        ...state[ action.contractorId.rawValue ].entries,
                        request: errorFetchingRequestState(action.error)
                    }
                }

            };
        default:
            return state;
    }
}